export const ConvertPhoneNumber = (number: any) => {
    let result = "";
    if (!isNaN(number)) {
        if (number.length === 11) {
            result = number.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        } else if (number.length === 8) {
            result = number.replace(/(\d{4})(\d{4})/, "$1-$2");
        } else {
            if (number.indexOf("02") === 0) {
                result = number.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
            } else {
                result = number.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
            }
        }
    } else {
        result = "-";
    }
    return result;
};
